<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="flex flex-wrap w-2/5 max-h-full bg-white shadow-lg rounded-lg px-5 pb-5 overflow-auto"
      >
        <div class="flex w-full flex-col sticky top-0 bg-white pt-5 z-50">
          <div class="flex">
            <div
              class="w-4/5 text-left px-3 pb-3 text-purple-700 text-2xl font-bold"
            >
              Especificaciones de la fotografía
            </div>
            <div class="w-1/5 text-right">
              <button
                aria-label="close"
                class="text-xl text-gray-500"
                @click.prevent="close"
              >
                ×
              </button>
            </div>
          </div>
        </div>
        <div class="w-full px-4 py-2 h-full">
          {{ especificacion }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "project-media-modal",
  data() {
    return {
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    especificacion: {
      required: true,
    },
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
  },
  components: {},
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
